class mBackBtn extends HTMLDivElement {
    constructor() {
        super();
        this.backBtn = document.querySelector('[is="m-back-button"]');
    }

    connectedCallback() {
        this.backBtn.addEventListener('click', () => {
            this.backToPreviousPage();
        });
    }

    backToPreviousPage() {
        window.history.back();
    }
}

customElements.define('m-back-button', mBackBtn, {
    extends: 'div'
});
